export const my = {
  certificates: "Mis certificados",
  activity: "Mi actividad",
  certificatesDescription:
    "Para usarlos, abre Punto.Firma en tu Mac y entra con esta cuenta.",
  downloadApp: "Descargar la app",
  empty: {
    title: "Todavía no puedes usar ningún certificado",
    description:
      "Pide a un administrador de tu organización que te dé acceso a los que necesites.",
  },
  card: {
    expires: "caduca {{date}}",
    expiresSoon: "Caduca {{when}}",
    where: "Dónde",
    uses: "Para",
    notAllowed: "No permitido: {{items}}.",
    notAllowedItem: "{{what}} en {{sede}}",
    somePaths: "algunas páginas",
    suspended: "Suspendido por tu administrador",
    noValidVersion: "Sin versión válida: tu administrador tiene que renovarlo",
    nowhere: "Sin sedes permitidas",
  },
  activityDescription:
    "Tus firmas y tu navegación con certificados del cloud. Lo ven también los administradores de tu organización.",
  activityTabs: {
    signatures: "Mis firmas",
    navigation: "Mi navegación",
  },
};
